module.exports = __webpack_public_path__ + "static/media/westbury-logo.96fb0434.svg";